import { z } from "zod";

export function isValidCNPJ(cnpj: string) {
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj.length !== 14) return false;

  const invalidCNPJs = [
    "00000000000000",
    "11111111111111",
    "22222222222222",
    "33333333333333",
    "44444444444444",
    "55555555555555",
    "66666666666666",
    "77777777777777",
    "88888888888888",
    "99999999999999"
  ];

  if (invalidCNPJs.includes(cnpj)) return false;

  let size = cnpj.length - 2;
  let numbers = cnpj.substring(0, size);
  const digits = cnpj.substring(size);
  let sum = 0;
  let pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i), 10) * pos--;
    if (pos < 2) pos = 9;
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0), 10)) return false;

  size += 1;
  numbers = cnpj.substring(0, size);
  sum = 0;
  pos = size - 7;

  for (let i = size; i >= 1; i--) {
    sum += parseInt(numbers.charAt(size - i), 10) * pos--;
    if (pos < 2) pos = 9;
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(1), 10)) return false;

  return true;
}

export function isValidCPF(cpf: string) {
  cpf = cpf.replace(/[^\d]+/g, "");

  if (cpf.length !== 11) return false;

  const invalidCPFs = [
    "00000000000",
    "11111111111",
    "22222222222",
    "33333333333",
    "44444444444",
    "55555555555",
    "66666666666",
    "77777777777",
    "88888888888",
    "99999999999"
  ];

  if (invalidCPFs.includes(cpf)) return false;

  let sum = 0;
  let remainder;

  // Verifica o primeiro dígito verificador
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
  }

  remainder = (sum * 10) % 11;

  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.substring(9, 10), 10)) return false;

  sum = 0;

  // Verifica o segundo dígito verificador
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
  }

  remainder = (sum * 10) % 11;

  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.substring(10, 11), 10)) return false;

  return true;
}

export const isValidCard = (card: string) => {
  card = card.replace(/[^\d]+/g, "");
  return card.length === 16;
};

export const validateEmails = (params: {
  email: string;
  confirmEmail: string;
  receiveViaEmail: boolean;
}): z.IssueData[] => {
  const issues: z.IssueData[] = [];
  const { email, confirmEmail, receiveViaEmail } = params;

  if (!receiveViaEmail) return issues;

  const trimmedEmail = email.trim();
  const trimmedConfirm = confirmEmail.trim();

  if (!trimmedEmail) {
    issues.push({
      code: z.ZodIssueCode.custom,
      message: "É necessário informar o e-mail.",
      path: ["email"]
    });
  } else if (!z.string().email().safeParse(trimmedEmail).success) {
    issues.push({
      code: z.ZodIssueCode.custom,
      message: "É necessário informar um e-mail válido.",
      path: ["email"]
    });
  }

  if (!trimmedConfirm) {
    issues.push({
      code: z.ZodIssueCode.custom,
      message: "É necessário confirmar o e-mail.",
      path: ["confirmEmail"]
    });
  }

  if (trimmedEmail && trimmedConfirm && trimmedEmail !== trimmedConfirm) {
    issues.push({
      code: z.ZodIssueCode.custom,
      message: "Os e-mails informados não coincidem.",
      path: ["confirmEmail"]
    });
  }

  return issues;
};
